const getTitleForStep = (step: number): string => {
  const titles: { [key: number]: string } = {
    1: 'Ver conteúdo do curso',
    2: 'Encontrar oportunidades',
    3: 'Analisar o mercado',
    4: 'Gerenciar licitações',
  };
  return titles[step] || 'Etapa desconhecida';
};

export default getTitleForStep;
